import React from 'react';
import { Sun, Moon } from 'react-feather';
import { Button } from 'antd';
import { useTheme } from '../../hook/useTheme';

const ThemeToggle: React.FC = () => {
  const { theme, toggleTheme } = useTheme();

  const handleToggle = () => {
    toggleTheme();
  };

  return (
    <Button
      type="text"
      icon={theme === 'light' ? <Moon className="w-4 h-4" /> : <Sun className="w-4 h-4" />}
      onClick={handleToggle}
      className="flex items-center justify-center w-8 h-8 p-0 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
      title={theme === 'light' ? 'Switch to dark mode' : 'Switch to light mode'}
    />
  );
};

export default ThemeToggle; 